<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh1">FRONT COVER</h2>
<p class="nofindent">South African engineers of No. 11 Field Company, South African Engineer Corps, clearing Route 6, the main road through Cassino, for armour of C Squadron of the 19th NZ Armoured Regiment on May 18, 1944 — the day Cassino finally fell after a bitter four-month struggle. Castle Hill rises in the background. The picture was taken by AFPU photographer Sergeant Bowman.</p>
<h2 class="fmh1t">FRONT ENDPAPER</h2>
<p class="nofindent">Cassino under American attack. Smoke from shelling and mortaring rises from the north-ern end of the town on February 10 in the final phase of the First Battle, when the 133rd Infantry of the US 34th Division was trying to fight its way into the town. The picture was taken by Signal Corps photo-grapher 2nd Lieutenant Jacob Harris from the lower reaches of Monte Trocchio. Rising on the left is Monastery Hill crowned by the Monte Cassino abbey. The Rapido river can be seen in the foreground.</p>
<div class="img_container">
<img alt="Images" src="images/fend.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Frontendpaper.vue?4875112c